// Players the desktop helper (VoteBeats Bridge) can detect, listed on the Platforms page.

/** All known players, in display order */
export const ALL_PLAYERS: Array<{
  name: string;
  platforms: ('Windows' | 'Mac')[];
  hasDeepLinkSearch: boolean;
  hasDeepLinkPlay: boolean;
  category: 'streaming' | 'local' | 'other';
}> = [
  { name: 'Spotify',              platforms: ['Windows', 'Mac'], hasDeepLinkSearch: true,  hasDeepLinkPlay: true,  category: 'streaming' },
  { name: 'Apple Music',          platforms: ['Mac', 'Windows'], hasDeepLinkSearch: true,  hasDeepLinkPlay: false, category: 'streaming' },
  { name: 'Amazon Music',         platforms: ['Windows', 'Mac'], hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'streaming' },
  { name: 'YouTube Music',        platforms: ['Windows', 'Mac'], hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'streaming' },
  { name: 'foobar2000',           platforms: ['Windows'],        hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'local' },
  { name: 'MusicBee',             platforms: ['Windows'],        hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'local' },
  { name: 'AIMP',                 platforms: ['Windows'],        hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'local' },
  { name: 'Windows Media Player', platforms: ['Windows'],        hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'local' },
  { name: 'VLC',                 platforms: ['Windows', 'Mac'], hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'local' },
  { name: 'iTunes',              platforms: ['Windows', 'Mac'], hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'local' },
  { name: 'Winamp',              platforms: ['Windows'],        hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'local' },
  { name: 'Browser',             platforms: ['Windows', 'Mac'], hasDeepLinkSearch: false, hasDeepLinkPlay: false, category: 'other' },
];
